import { styled } from 'styled-components';

interface WrapperProps {
  $offset: number;
}

export const Wrapper = styled.div<WrapperProps>`
  position: sticky;
  top: ${({ $offset }) => `${$offset}px`};
  gap: 24px;
  display: flex;
  flex-direction: column;
`;
